export default {
    headerContainer: {
        width: "100%",
        padding: "10px 20px 0px 20px",
    },

    titleAndSearch: {
        paddingBottom: "30px",
        display: "flex",
        justifyContent: "space-between"
    },

    icons: {
        display: "flex",
        columnGap: '15px',
        alignItems: "center"
    },

    dropdownContainer: {
        width: "135px",
        marginRight: "20px"
    },

    dropdownInput: {
        caretColor: "transparent",
    },

    searchContainer: {
        display: "flex",
    },

    noPayersFoundContainer: {
        textAlign: "center",
        marginTop: "100px"
    },

    iconStyle: {
        cursor: "pointer"
    },

    action: {
        display: "flex",
        columnGap: "8px"
    },

    deleteIconStyle: {
        cursor: "pointer",
        height: "25px",
        width: "20px"
    }

}